module.exports = __webpack_public_path__ + "static/img/yuli.4d4e5c99.png";